<template>
    <span>
        <el-tree-select 
            class="filterItem-value"
            v-if="showInput" 
            v-model="filterItem.value[0]" 
            :data="deaprtOptions" 
            show-checkbox 
            check-strictly/>
        <el-tree-select 
            clearable
            class="filterItem-value"
            v-if="showMultSelect" 
            v-model="filterItem.value" 
            :data="deaprtOptions" 
            collapse-tags
            collapse-tags-tooltip
            multiple 
            show-checkbox 
            check-strictly/>
    </span>
</template>

<script>
    import baseFilter from "../../BaseFilter"
    import Tree from '@/components/Tree/Tree.vue'
    import { listToTree } from "@/common/commonHelper"
    import { getDepart } from "@/apis/httpHelper"
    
    export default {
        name:"SingleDepartFieldFilter",
        mixins:[baseFilter],
        components:{
            'tree':Tree
        },
        created:function(){
            getDepart()
                .then(x=>{
                    this.departList = x.Result;
                    this.deaprtOptions = listToTree(x.Result).map(x=> this.mapToElTree(x));
                }).catch(x=>{
                    console.log(x);
                });
        },
        data:function(){
            return {
                deaprtOptions:[],
                departList:[]
            }
        },
        methods:{
            mapToElTree:function(tree){
                let result = {};
                result.value = tree.Id;
                result.label = tree.Name;
                if(tree.Children.length > 0){
                    result.children = tree.Children.map(x=> this.mapToElTree(x))
                }
                return result;
            }
        }
    }
</script>